export const PERSIST_CONFIG = {
    key: "Wakaroot-Vbp82Vpq418w1A2eNRBz",
    secretKey: "k4CoKyofvaFBMeiqPEcvchmXIKXjEz7FNWrR16y14AjS1HJWf5"
}